// Copyright (c) StrangeBee 2023

import React, { useState, ReactElement } from 'react';
import { Image, Upload } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import DeleteButton from '@Atoms/Buttons/DeleteButton/DeleteButton';
import { useLocalMessage } from '@Helpers/locale';
import { classList } from '@Helpers/className';

import './UploadImage.scss';
import { ICONS } from '@Constants/iconsApp';
import { fallbackImage } from '@Constants/image';

export interface UploadImageProps {
    name?: string;
    className?: string;
    onChange?: (data: UploadFile<any> | undefined) => void;
    onRemove?: (data: string) => void;
    value?: string | undefined;
}

export const UploadImage = ({ value, onChange, name, onRemove, className }: UploadImageProps): ReactElement => {
    const i = useLocalMessage();
    const [loading, setLoading] = useState<boolean>(false);
    const [imageUrl, setImageUrl] = useState<string>(value || '');

    const onUpload = ({ file }: any): void => {
        setLoading(true);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setImageUrl(reader.result?.toString() || '');
            onChange?.(file);
            setLoading(false);
        };
    };

    return (
        <div className={classList('upload-image', className)}>
            <Upload
                showUploadList={false}
                customRequest={onUpload}
                className="upload-image__input"
                accept=".png,.jpg,.jpeg,.ico"
            >
                {loading ? (
                    <ICONS.LoadingIcon />
                ) : (
                    <Image
                        className="upload-image__preview"
                        preview={false}
                        fallback={fallbackImage}
                        width={200}
                        src={imageUrl}
                    />
                )}
            </Upload>
            {imageUrl !== '' ? (
                <DeleteButton
                    label={i('account.clearConfirm')}
                    onConfirm={() => {
                        onRemove?.(name || '');
                        onChange?.(undefined);
                        setImageUrl('');
                    }}
                />
            ) : null}
        </div>
    );
};
